module.exports = __webpack_public_path__ + "static/media/evento-carioca-anime-cracha-personalizado.ac96ff43.jpg";